import * as React from 'react';

import { Button } from '../../button/button.tsx';
import { Icon } from '../../icon/icon';

import { UploadedFile } from '../types.ts';

import './file-uploaded-chip.css';

interface FileUploadedChipProps extends React.HTMLAttributes<HTMLDivElement> {
  file: UploadedFile;
  onDelete?: React.MouseEventHandler<HTMLButtonElement>;
}

const FileUploadedChip = React.forwardRef<
  HTMLDivElement,
  FileUploadedChipProps
>(({ file, onDelete, ...props }, ref) => {
  return (
    <div className="file-uploaded-chip" ref={ref} {...props}>
      <Icon
        type="attach"
        size="medium"
        color="var(--color_primary-darkest)"
        className="i-color"
      />
      <span className="fuc-label">{file.name}</span>
      {onDelete != null && (
        <Button type="button" asRemoveIcon="color" onClick={onDelete} />
      )}
    </div>
  );
});

export { FileUploadedChip };
